import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowSplitUp: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-split-up, rules, direction, split"><path d="M3.75 9.25V3.75H9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.75 3.75H20.25V9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 12V20.25M12 12L4.5 4.5M12 12L19.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowSplitUp;
